/**
 * Drag item types for react dnd
 */
export const DND_TYPES = {
  FILE_TAB: 'file-tab',
};
